/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
export default function Preloader() {
  return (
    <>
    <div className="preloader">
      <div className="loading-container">
        <div className="loading"></div>
        <div id="loading-icon">
          <img src="/images/img/loading.png" alt="" />
        </div>
      </div>
    </div>
    </>
  );
}
